import request from '../requestPB'
import { SERVER_DOMAIN as preFix, PROTO_MODULE, USERCENTER_DOMAIN } from '../constant'

// 手机号登录 若无uid先注册 POST /account/phoneSignIn
export const logIn = (param) => {
  return request({
    url: `${preFix}/account/phoneSignIn`,
    data: param,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSLogInRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSLogInResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: !true
  })
}

// 验证码请求 POST /account/sendSms
export const sendSmsCode = (data) => {
  return request({
    url: `${preFix}/account/sendSms`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSSendSmsCodeRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSSendSmsCodeResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.USER,
    TOKEN_REQUIRED: !true
  })
}



/** **********************************
 * 2021.11.11 新用户中心接口 POST  *******
 * ***********************************
 * */ 

// 用户验证码请求     /api/v1/account/sendSmsCode
export const fetchSMSCode = (data) => {
  return request({
    url: `${USERCENTER_DOMAIN}/api/v1/account/sendSmsCode`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'ussRpc.USSSendSMSCodeRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'ussRpc.USSSendSMSCodeResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'user',
  })
}

// 用户手机号登录     /api/v1/account/phoneSignIn
export const phoneLogin = (data) => {
  return request({
    url: `${USERCENTER_DOMAIN}/api/v1/account/phoneSignIn`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'ussRpc.USSPhoneSignInRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'ussRpc.USSPhoneSignInResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'user',
  })
}